import { Link } from 'react-router-dom'
import type { TemplateCardData } from '../lib/templateTypes'
import LivePreview from './LivePreview'

/**
 * Gallery card — the whole card is one link. The framed 16:10 area is a live
 * preview of the template's deployed site (non-interactive; the card owns the
 * click). Only templates with a live URL are ever surfaced, so there is always
 * a URL to render.
 */
export default function TemplateCard({
  template,
  eager = false,
}: {
  template: TemplateCardData
  eager?: boolean
}) {
  return (
    <Link
      to={`/templates/${template.slug}`}
      className="od-tpl-card"
      aria-label={`${template.name} template`}
    >
      <span className="od-tpl-card-shot">
        <LivePreview
          url={template.liveDemoUrl}
          title={template.name}
          eager={eager}
        />
      </span>
      <span className="od-tpl-card-name">{template.name}</span>
      <span className="od-tpl-card-cat">{template.category.toLowerCase()}</span>
      <span className="od-tpl-card-line">{template.oneLiner}</span>
    </Link>
  )
}
